import styled from 'vue-styled-components';
import { color } from '@rawlplug/rawlplug-design-style-tokens/dist/web/colors';
import { Slide } from 'vue-burger-menu';
import ClickOutside from 'vue-click-outside';
import { Component, Prop, Vue as Vue$1 } from 'vue-property-decorator';
import Vue from 'vue';
import CollapseTransition from '@ivanv/vue-collapse-transition';

const SCROLL_DOWN = 'scroll-down';
const SCROLL_UP = 'scroll-up';
const scrollDirectionMixin = {
  data() {
    return {
      lastScrollPosition: 0,
      scrollDirection: null
    };
  },

  created() {
    window.addEventListener("scroll", this.checkScrollDirection);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.checkScrollDirection);
  },

  methods: {
    checkScrollDirection() {
      const currentScrollPosition = window.pageYOffset;
      const lastScrollPosition = this.lastScrollPosition;

      if (currentScrollPosition === 0) {
        this.scrollDirection = null;
        return;
      }

      if (currentScrollPosition > lastScrollPosition) {
        this.scrollDirection = SCROLL_DOWN;
      } else if (currentScrollPosition < lastScrollPosition) {
        this.scrollDirection = SCROLL_UP;
      }

      this.lastScrollPosition = currentScrollPosition;
    }

  }
};

//
const PAGE_Y_OFFSET = 64;
var script = {
  mixins: [scrollDirectionMixin],
  props: {
    pageYOffset: {
      type: Number,
      default: PAGE_Y_OFFSET
    },
    headerHeight: {
      type: Number,
      default: 64 // TODO - przerobić by headerHeight był liczony automatycznie

    },
    headerWrapperHeight: {
      type: Number
    },
    headerInitialFixed: {
      type: Boolean,
      default: false
    },
    addScrollDirectionClass: {
      props: Boolean,
      default: true
    }
  },
  data: () => ({
    currentPageYOffset: 0
  }),

  created() {
    window.addEventListener("scroll", this.updatePageYOffset);
  },

  computed: {
    isSticky() {
      return this.currentPageYOffset > this.pageYOffset;
    },

    classes() {
      const scrollDirection = this.addScrollDirectionClass ? {
        [this.scrollDirection]: this.scrollDirection
      } : {};
      return {
        'is-sticky': this.isSticky,
        ...scrollDirection
      };
    },

    styles() {
      return {
        '--header-height': `${this.headerHeight}px`,
        '--header-wrapper-height': this.headerWrapperHeight ? `${this.headerWrapperHeight}px` : '',
        '--header-initial-position': this.headerInitialFixed ? 'fixed' : 'relative',
        '--sticky-transform': `translateY(${this.headerHeight * -1}px)`
      };
    }

  },
  methods: {
    updatePageYOffset() {
      this.currentPageYOffset = window.pageYOffset;
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "ldp-header-wrapper",
    style: _vm.styles
  }, [_c('header', {
    staticClass: "ldp-header",
    class: _vm.classes
  }, [_vm._t("default", null, {
    "isSticky": _vm.isSticky,
    "scrollDirection": _vm.scrollDirection
  })], 2)]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-e2cacf10_0", {
    source: ".ldp-header-wrapper[data-v-e2cacf10]{height:var(--header-wrapper-height)}header[data-v-e2cacf10]{position:var(--header-initial-position);top:0;right:0;left:0;z-index:202;transition:transform .4s}header.is-sticky[data-v-e2cacf10]{position:fixed;transform:var(--sticky-transform)}header.is-sticky.scroll-up[data-v-e2cacf10]{transform:translateY(0)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-e2cacf10";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

const HeaderBottom = styled('div', {
  backgroundColor: {
    default: "#1c5188"
  }
})`
    height: 40px;
    background-color: ${props => props.backgroundColor};
    display: none;
    
    @media (min-width: 576px) {
        display: block;
    }
`;

const HeaderMobile = styled('div', {
  backgroundColor: {
    default: "#003366"
  }
})`
    height: 32px;
    background-color: ${props => props.backgroundColor};
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #ffffff;
    
    @media (min-width: 576px) {
        display: none;
    }
`;

const HeaderTop = styled('div', {
  backgroundColor: {
    default: "#003366"
  }
})`
    height: 64px;
    background-color: ${props => props.backgroundColor};
    color: #fff;
    display: none;
    
    .wrapper {
        display: flex;
        align-items: center;
        height: 100%;
    }
    
    @media (min-width: 576px) {
        display: block;
    }
`;

const HeaderTopContainer = styled.div`
    width: 100%;
    height: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    
    @media (min-width: 576px) {
        max-width: 540px;
    }
    
    @media (min-width: 768px) {
        max-width: 720px;
    }
    
    @media (min-width: 992px) {
        max-width: 960px;
    }
    
    @media (min-width: 1200px) {
        max-width: 1140px;
    }
`;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  props: {
    menuItems: {
      type: Array,
      required: true
    },
    value: {
      required: true
    },
    offset: {
      type: Number,
      default: 120
    },
    scrollOffset: {
      type: Number,
      default: null
    }
  },
  methods: {
    menuClick(menuItem) {
      this.$emit('input', menuItem);
    },

    itemchanged(event, currentItem, lastActiveItem) {
      if (currentItem) {
        currentItem = this.menuItems.find(menuItem => menuItem.href === currentItem.hash);
        this.$emit('input', currentItem);
      }
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('nav', [_c('scrollactive', {
    staticClass: "header-navigation",
    attrs: {
      "offset": _vm.offset,
      "tag": "ul",
      "scrollOffset": _vm.scrollOffset
    },
    on: {
      "itemchanged": _vm.itemchanged
    }
  }, _vm._l(_vm.menuItems, function (menuItem) {
    return _c('li', {
      key: menuItem.href,
      staticClass: "header-navigation__item",
      class: {
        'is-active': menuItem === _vm.value
      }
    }, [_c('a', {
      staticClass: "scrollactive-item",
      attrs: {
        "href": menuItem.href
      },
      on: {
        "click": function ($event) {
          return _vm.menuClick(menuItem);
        }
      }
    }, [_vm._v("\n                    " + _vm._s(menuItem.label) + "\n                ")])]);
  }), 0)], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-423159e6_0", {
    source: "nav ul[data-v-423159e6]{list-style-type:none;padding:0;margin:0;height:100%;gap:clamp(10px,4vw,40px);display:flex}nav li[data-v-423159e6]{list-style-type:none;margin-right:0}nav li a[data-v-423159e6]{position:relative;display:block;color:#fff;text-decoration:none;height:100%;border-bottom:3px solid transparent;line-height:24px;display:flex;justify-content:center;align-items:center;transform:translateY(1px)}nav li a[data-v-423159e6]::after{content:\"\";bottom:-2px;height:3px;width:100%;position:absolute;background-color:transparent}nav li.is-active>a[data-v-423159e6]:after{background-color:#ff8a00}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1 = "data-v-423159e6";
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

//
const colorRawlplugBlue = color.rwl.blue[90].value;
const colorHover = color.rwl.cyan[100].value;
var script$2 = {
  name: 'MobileNavigation',
  components: {
    Slide
  },
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    backgroundColor: {
      type: String,
      default: colorRawlplugBlue
    },
    colorHover: {
      type: String,
      default: colorHover
    },
    translationDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickItem(item) {
      this.$refs.slide.closeMenu();
      this.$emit('input', item);
    },

    getName(item) {
      return this.translationDisabled ? item.name : this.$t(item.term);
    }

  },
  computed: {
    style() {
      return {
        '--color-hover': this.colorHover,
        '--background-color': this.backgroundColor
      };
    }

  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "mobile-navigation",
    style: _vm.style
  }, [_c('Slide', {
    ref: "slide",
    attrs: {
      "right": "",
      "width": "180",
      "closeOnNavigation": true
    }
  }, [_c('scrollactive', {
    attrs: {
      "tag": "ul"
    }
  }, _vm._l(_vm.menuItems, function (item) {
    return _c('li', {
      key: item.href,
      staticClass: "menu-item"
    }, [_c('a', {
      staticClass: "scrollactive-item",
      attrs: {
        "href": item.href
      },
      on: {
        "click": _vm.clickItem
      }
    }, [_vm._v(_vm._s(item.label))])]);
  }), 0)], 1)], 1);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-3e38bd4e_0", {
    source: ".bm-burger-bars{background-color:#fff!important}.bm-burger-button{top:5px!important;height:22px!important;transform:translateX(28px)}.bm-menu{background-color:var(--background-color);min-height:1000px;z-index:1030!important}.bm-cross{background:#fff!important}.bm-cross-button{left:20px!important}.bm-item-list{color:#fff!important}",
    map: undefined,
    media: undefined
  }), inject("data-v-3e38bd4e_1", {
    source: ".mobile-navigation[data-v-3e38bd4e]{width:64px;height:100%;display:flex;justify-content:center;align-items:center;position:relative}.toggle-button[data-v-3e38bd4e]{background-color:transparent;border:none;outline:0;cursor:pointer}.icon-hamburger path[data-v-3e38bd4e]{stroke:#fff}.toggle-menu[data-v-3e38bd4e]{display:none;position:absolute;top:100%;background-color:#fff;right:0;z-index:10}.toggle-menu.is-open[data-v-3e38bd4e]{display:block}.toggle-menu__item[data-v-3e38bd4e]{cursor:pointer;list-style-type:none;padding:8px 8px;color:var(--background-color)}.scrollactive-nav[data-v-3e38bd4e]{flex-direction:column}li[data-v-3e38bd4e]{cursor:pointer;list-style-type:none;padding:8px 8px;color:var(--background-color)}.scrollactive-item[data-v-3e38bd4e]{color:#fff;text-decoration:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$2 = "data-v-3e38bd4e";
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

//
const colorRawlplugBlue$1 = color.rwl.blue[100].value;
const colorHover$1 = color.rwl.cyan[100].value;
var script$3 = {
  name: "LanguageSwitcher",
  props: {
    backgroundColor: {
      type: String,
      default: colorRawlplugBlue$1
    },
    colorHover: {
      type: String,
      default: colorHover$1
    }
  },
  directives: {
    ClickOutside
  },

  data() {
    return {
      open: false,
      languages: []
    };
  },

  created() {
    this.languages = this.$i18n.availableLocales;
  },

  methods: {
    toggleMenu() {
      this.open = !this.open;
    },

    setLangauge(language) {
      this.$root.$i18n.locale = language;
      this.open = false;
    },

    hide() {
      this.open = false;
    }

  },
  computed: {
    style() {
      return {
        '--color-hover': this.colorHover,
        '--background-color': this.backgroundColor
      };
    },

    currentLanguageCode() {
      return String(this.$i18n.locale).toUpperCase();
    }

  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('nav', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.hide,
      expression: "hide"
    }],
    staticClass: "language-switcher",
    class: {
      'is-open': _vm.open
    },
    style: _vm.style
  }, [_c('button', {
    staticClass: "language-switcher__toggle",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('svg', {
    staticClass: "icon-earth",
    attrs: {
      "width": "22",
      "height": "22",
      "viewBox": "0 0 22 22",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 11H21",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11 1C13.5013 3.73835 14.9228 7.29203 15 11C14.9228 14.708 13.5013 18.2616 11 21C8.49872 18.2616 7.07725 14.708 7 11C7.07725 7.29203 8.49872 3.73835 11 1V1Z",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentLanguageCode))]), _vm._v(" "), _c('svg', {
    staticClass: "icon-arrow-down",
    class: {
      'rotated': _vm.open
    },
    attrs: {
      "width": "10",
      "height": "10",
      "viewBox": "0 0 10 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 1L5 5L9 1",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "toggle-menu",
    class: {
      'is-open': _vm.open
    }
  }, _vm._l(_vm.languages, function (language) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "/" + language
      }
    }, [_vm._v("\n                " + _vm._s(language.toUpperCase()) + "\n            ")])]);
  }), 0)]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-3b488223_0", {
    source: ".language-switcher[data-v-3b488223]{position:relative;color:#fff;height:100%}.language-switcher__toggle[data-v-3b488223]{cursor:pointer;height:100%;display:flex;align-items:center;color:#fff;padding:0 2px;border:none;outline:0;background-color:var(--background-color)}.language-switcher__toggle .icon-earth path[data-v-3b488223]{stroke:#fff;transition:stroke ease-in-out .2s}.language-switcher__toggle>span[data-v-3b488223]{font-size:16px;line-height:24px;min-width:30px;margin-left:8px;margin-right:8px}.is-open>.language-switcher__toggle[data-v-3b488223]{background-color:#fff;color:var(--background-color)}.is-open>.language-switcher__toggle .icon-earth path[data-v-3b488223]{stroke:var(--background-color)}.is-open>.language-switcher__toggle .icon-arrow-down path[data-v-3b488223]{stroke:var(--background-color)}@media all and (min-width:992px){.language-switcher__toggle[data-v-3b488223]{padding:0 16px;padding-left:4px}}.icon-arrow-down[data-v-3b488223]{display:none;transform:rotate(0) translateY(2px);transition:transform ease-in-out .2s}.icon-arrow-down.rotated[data-v-3b488223]{transform:rotate(180deg) translateY(2px)}@media all and (min-width:992px){.icon-arrow-down[data-v-3b488223]{display:block}}.toggle-menu[data-v-3b488223]{position:absolute;top:100%;width:100%;display:none;background-color:#fff}.toggle-menu.is-open[data-v-3b488223]{display:flex;flex-direction:column}.toggle-menu li[data-v-3b488223]{cursor:pointer;color:var(--background-color)}.toggle-menu li a[data-v-3b488223]{padding:8px 8px;display:block;color:inherit}.toggle-menu li[data-v-3b488223]:hover{color:var(--color-hover)}.header-mobile .language-switcher__toggle .icon-earth[data-v-3b488223]{margin-left:8px}.header-mobile .language-switcher__toggle>span[data-v-3b488223]{font-size:12px;margin-left:0;margin-right:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$3 = "data-v-3b488223";
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

//
var script$4 = {
  name: "StickyFooter",
  mixins: [scrollDirectionMixin],
  computed: {
    scrollDirectionClasses() {
      return {
        [this.scrollDirection]: true
      };
    }

  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('footer', {
    staticClass: "sticky-footer",
    class: Object.assign({}, _vm.scrollDirectionClasses)
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-8f6580cc_0", {
    source: "footer[data-v-8f6580cc]{position:fixed;background-color:#1c5188;left:0;right:0;bottom:0;width:100%;transition:transform .4s;padding:8px;display:flex;justify-content:space-between;z-index:1001}footer.scroll-down[data-v-8f6580cc]{transform:translate3d(0,100%,0)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = "data-v-8f6580cc";
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

function smoothScrollTo(top) {
  const isSmoothScrollSupported = ('scrollBehavior' in document.documentElement.style);
  const options = {
    "behavior": "smooth",
    "left": 0,
    "top": top
  };

  if (isSmoothScrollSupported) {
    window.scrollTo(options);
  } else {
    window.scrollTo(options.left, options.top);
  }
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root.Date.now();
};

var now_1 = now;

/** Built-in value references. */
var Symbol = _root.Symbol;

var _Symbol = Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

//
var script$5 = {
  name: 'GoToTop',
  props: {
    foldingLineY: {
      default: 100
    },
    backgroundColor: {},
    hoverBackgroundColor: {},
    fillColor: {},
    right: {},
    bottom: {}
  },

  data() {
    return {
      isFoldingLine: false
    };
  },

  methods: {
    goToTop() {
      smoothScrollTo(0);
    },

    handleScroll(event) {
      if (window.scrollY > this.foldingLineY) {
        this.isFoldingLine = true;
      } else {
        this.isFoldingLine = false;
      }
    }

  },
  computed: {
    style() {
      return {
        '--go-to-top-right': this.right,
        '--go-to-top-bottom': this.bottom,
        '--go-to-top-background-color': this.backgroundColor,
        '--go-to-top-hover-background-color': this.hoverBackgroundColor,
        '--go-to-top-fill-color': this.fillColor
      };
    }

  },

  created() {
    this.handleDebouncedScroll = debounce_1(this.handleScroll, 100);
    window.addEventListener('scroll', this.handleDebouncedScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleDebouncedScroll);
  }

};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "gototop-fade"
    }
  }, [_vm.isFoldingLine ? _c('span', {
    staticClass: "go-to-top",
    style: _vm.style,
    attrs: {
      "id": "goToTop"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.goToTop.apply(null, arguments);
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "15",
      "height": "9",
      "viewBox": "0 0 15 9"
    }
  }, [_c('path', {
    attrs: {
      "d": "M286.883,866.39l5.614,5.895,5.687-5.971h0a1.044,1.044,0,0,1,.744-0.316A1.1,1.1,0,0,1,300,867.123a1.152,1.152,0,0,1-.3.781h0l-6.428,6.75h0a1.043,1.043,0,0,1-.771.344h0a1.044,1.044,0,0,1-.771-0.344h0L285.3,867.9l0,0a1.153,1.153,0,0,1-.3-0.779A1.1,1.1,0,0,1,286.071,866,1.05,1.05,0,0,1,286.883,866.39Z",
      "transform": "translate(-285 -866)"
    }
  })])]) : _vm._e()]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-76682f64_0", {
    source: ".gototop-fade-enter-active[data-v-76682f64],.gototop-fade-leave-active[data-v-76682f64]{transition:opacity .5s}.gototop-fade-enter[data-v-76682f64],.gototop-fade-leave-to[data-v-76682f64]{opacity:0}.go-to-top[data-v-76682f64]{width:40px;height:40px;border-radius:50%;background-color:var(--go-to-top-background-color,#1c5188);box-shadow:0 4px 14px -7px rgba(0,0,0,.51);position:fixed;bottom:var(--go-to-top-bottom,20px);right:var(--go-to-top-right,20px);cursor:pointer;z-index:99;transition:background-color .3s ease-in-out,all .3s ease-in-out}.go-to-top[data-v-76682f64]:hover{background-color:var(--go-to-top-hover-background-color,#3e6295)}.go-to-top svg[data-v-76682f64]{position:absolute;top:50%;left:50%;fill:var(--go-to-top-fill-color,#000);transform:translate(-50%,-50%) rotate(180deg)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$5 = "data-v-76682f64";
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

function _initializerDefineProperty(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }

  return desc;
}

var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2, _temp;
let VideoBlock = (_dec = Component({
  name: "VideoBlock"
}), _dec2 = Prop(), _dec3 = Prop({}), _dec(_class = (_class2 = (_temp = class VideoBlock extends Vue {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "title", _descriptor, this);

    _initializerDefineProperty(this, "backgroundImage", _descriptor2, this);
  }

  get style() {
    return {
      '--background-image': `url('${this.backgroundImage}')`
    };
  }

  showVideo() {
    this.$emit('showVideo');
  }

  closeModal() {
    this.$emit('hideVideo');
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "title", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "backgroundImage", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);

/* script */
const __vue_script__$6 = VideoBlock;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', {
    staticClass: "video-block",
    style: _vm.style
  }, [_c('div', {
    staticClass: "video-block__overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "video-block__body"
  }, [_vm.title ? _c('div', {
    staticClass: "video-block__title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "icon-play",
    attrs: {
      "width": "80",
      "height": "80",
      "viewBox": "0 0 80 80",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": _vm.showVideo
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M40 -0.000976562C17.908 -0.000976562 0 17.907 0 39.999C0 62.09 17.908 79.999 40 79.999C62.091 79.999 80 62.09 80 39.999C80 17.907 62.091 -0.000976562 40 -0.000976562ZM40 76.666C19.782 76.666 3.333 60.217 3.333 39.999C3.333 19.781 19.782 3.33202 40 3.33202C60.218 3.33202 76.666 19.781 76.666 39.999C76.666 60.217 60.218 76.666 40 76.666ZM28.333 59.999L60 39.999L28.333 19.999V59.999ZM31.666 26.666L53.333 39.999L31.666 53.332V26.666Z"
    }
  })])]), _vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-3a0b6f30_0", {
    source: ".video-block[data-v-3a0b6f30]{min-height:400px;background-size:cover;background-image:var(--background-image);background-repeat:no-repeat;background-position:center;position:relative}.video-block svg[data-v-3a0b6f30]{transition:all .3s ease-in}.video-block svg[data-v-3a0b6f30]:hover{cursor:pointer;transform:scale(1.2)}.video-block__overlay[data-v-3a0b6f30]{position:absolute;left:0;top:0;right:0;bottom:0;background-color:#000;opacity:.4}.video-block__body[data-v-3a0b6f30]{position:absolute;left:0;top:0;right:0;bottom:0;display:flex;flex-direction:column;justify-content:center;align-items:center}.video-block__title[data-v-3a0b6f30]{font-size:24px;line-height:32px;color:#fff;margin-bottom:.5em}.video-block[data-v-3a0b6f30]  .icon-close{position:absolute;right:5px;top:5px;transform:scale(.8)}.video-block[data-v-3a0b6f30]  embed,.video-block[data-v-3a0b6f30]  iframe,.video-block[data-v-3a0b6f30]  object{left:5%;top:5%;height:80%;width:90%;position:absolute}.icon-play[data-v-3a0b6f30]{fill:#ff8a00}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$6 = "data-v-3a0b6f30";
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

var _temp$1;
var FeatureBlockVariant;

(function (FeatureBlockVariant) {
  FeatureBlockVariant["DEFAULT"] = "DEFAULT";
  FeatureBlockVariant["ICON_LEFT"] = "ICON_LEFT";
})(FeatureBlockVariant || (FeatureBlockVariant = {}));

const classMap = {
  [FeatureBlockVariant.DEFAULT]: 'feature-block--default',
  [FeatureBlockVariant.ICON_LEFT]: 'feature-block--icon-left'
};
let FeatureBlock = (_temp$1 = class FeatureBlock extends Vue$1 {
  constructor(...args) {
    super(...args);
    this.FeatureBlockVariant = FeatureBlockVariant;
  }

  // @Prop({ default: FeatureBlockVariant.DEFAULT }) variant!: string;
  //
  // @Prop({required: true}) feature!: Feature;
  get variantClassName() {
    // @ts-ignore
    return classMap[this.variant];
  }

}, _temp$1);
FeatureBlock = __decorate([Component({
  props: {
    variant: null,
    feature: null
  }
})], FeatureBlock);
var script$6 = FeatureBlock;

/* script */
const __vue_script__$7 = script$6;
/* template */

var __vue_render__$7 = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.feature ? _c('div', {
    staticClass: "feature-block",
    class: (_obj = {
      'has-popup': _vm.feature.imagePopup
    }, _obj[_vm.variantClassName] = true, _obj)
  }, [_c('div', {
    staticClass: "feature-block__image-wrapper"
  }, [_vm.variant === _vm.FeatureBlockVariant.DEFAULT ? [_vm.feature.imagePopup ? _c('img', {
    staticClass: "feature-block__image-popup",
    attrs: {
      "src": _vm.feature.imagePopup
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "feature-block__image",
    attrs: {
      "src": _vm.feature.image
    }
  })] : _vm._e(), _vm._v(" "), _vm.variant === _vm.FeatureBlockVariant.ICON_LEFT ? [_c(_vm.feature.image, {
    tag: "component",
    staticClass: "feature-block__image"
  })] : _vm._e()], 2), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.feature.description)
    }
  })]) : _vm._e();
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = function (inject) {
  if (!inject) return;
  inject("data-v-1b8c057a_0", {
    source: ".feature-block--default[data-v-1b8c057a]{display:flex;flex-direction:column;align-items:center;position:relative}.feature-block--default.feature-block__image-wrapper[data-v-1b8c057a]{position:relative;width:128px;height:128px;background-color:#472a1a;border-radius:50%;z-index:2}.feature-block--default.feature-block__image-wrapper[data-v-1b8c057a]:before{display:none;content:\"\";position:absolute;border-radius:50%;left:0;top:0;width:120px;height:124px;border:4px solid #00baff;z-index:-1}.feature-block--default.feature-block.has-popup .feature-block__image-wrapper[data-v-1b8c057a]::before{display:block}.feature-block--default.feature-block__image[data-v-1b8c057a]{border:5px solid #fff;border-radius:50%}.feature-block--default.feature-block__image-popup[data-v-1b8c057a]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);opacity:0;transition:opacity .3s ease-in-out;pointer-events:none}.feature-block--default.feature-block:hover .feature-block--default.feature-block__image-popup[data-v-1b8c057a]{opacity:1}.feature-block--icon-left[data-v-1b8c057a]{padding:8px}.feature-block--icon-left p[data-v-1b8c057a]{margin:0}.feature-block--icon-left[data-v-1b8c057a]{display:flex;gap:16px;max-width:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$7 = "data-v-1b8c057a";
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);

var IconFile = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"26","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M13 0H0v32h26V13.09L13 0zm10.957 13.09H13V2.058l10.957 11.034zm.599 17.456H1.444V1.454h10.112v13.09h13v16z"}})]) } };

var IconMonitor = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"36","height":"35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M18 19.975c-.829 0-1.5.662-1.5 1.48 0 .817.671 1.479 1.5 1.479.828 0 1.5-.662 1.5-1.48a1.49 1.49 0 00-1.5-1.479zm18 6.658V.001H0v26.632h14.25v5.889H10.5v1.48h15v-1.48h-3.75v-5.889H36zm-15.75 5.889h-4.5v-5.889h4.5v5.889zM1.5 25.154v-7.398h33v-1.48h-33V1.48h33v23.673h-33z"}})]) } };

var IconPhone = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20.888 15.92v3a2 2 0 01-2.18 2 19.791 19.791 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 012.998 1h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11l-1.27 1.27a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.574 2.81.7a2 2 0 011.72 2.03z","stroke":"#683C11","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]) } };

var IconProfile = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"36","height":"37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M18 .001c-9.941 0-18 8.059-18 18s8.059 18 18 18 18-8.058 18-18c0-9.941-8.059-18-18-18zM8.857 31.728h.001l1.508-7.393c.24-1.777 1.718-3.122 3.485-3.24 1.182.916 2.61 1.477 4.149 1.477 1.545 0 2.977-.566 4.163-1.489a3.79 3.79 0 013.613 3.302l1.484 7.265A16.405 16.405 0 0118 34.5c-3.38 0-6.524-1.023-9.143-2.773zM18 21c-3.072 0-6-3.357-6-6.75 0-3.236 2.763-6 6-6 3.236 0 6 2.764 6 6 0 3.393-2.928 6.75-6 6.75zm10.586 9.644l-1.331-6.511a5.289 5.289 0 00-3.774-4.358c1.17-1.446 2.019-3.634 2.019-5.525 0-4.07-3.43-7.5-7.5-7.5s-7.5 3.43-7.5 7.5c0 1.906.86 4.109 2.047 5.56-1.911.594-3.386 2.245-3.659 4.273l-1.36 6.659C3.85 27.713 1.5 23.127 1.5 18.001c0-9.098 7.402-16.5 16.5-16.5 9.098 0 16.5 7.402 16.5 16.5 0 5.072-2.302 9.614-5.914 12.644z"}})]) } };

var _dec$1, _dec2$1, _class$1, _class2$1, _descriptor$1, _temp$2;
let AsideItemComponent = (_dec$1 = Component({
  components: {
    IconFile,
    IconMonitor,
    IconPhone,
    IconProfile
  }
}), _dec2$1 = Prop(), _dec$1(_class$1 = (_class2$1 = (_temp$2 = class AsideItemComponent extends Vue$1 {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "item", _descriptor$1, this);
  }

}, _temp$2), (_descriptor$1 = _applyDecoratedDescriptor(_class2$1.prototype, "item", [_dec2$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2$1)) || _class$1);

/* script */
const __vue_script__$8 = AsideItemComponent;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.item.href !== '',
      expression: "item.href !== ''"
    }]
  }, [_c('a', {
    attrs: {
      "href": _vm.item.href,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c(_vm.item.icon, {
    tag: "component"
  }), _vm._v("\n        " + _vm._s(_vm.item.name) + "\n    ")], 1)]);
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$8 = function (inject) {
  if (!inject) return;
  inject("data-v-d82d7214_0", {
    source: "li[data-v-d82d7214]{list-style-type:none;margin:0;padding:0}li a[data-v-d82d7214]{display:flex;align-items:center;color:#ff8a00;text-decoration:none;transition:all .3s ease}li a[data-v-d82d7214]  svg{margin-right:13px}li a[data-v-d82d7214]  svg path{fill:var(--aside-link-color,#ff8a00);transition:all .3s ease}li a[data-v-d82d7214]:hover{color:var(--aside-link-hover-color,#ffad4d)}li a[data-v-d82d7214]:hover  svg path{fill:var(--aside-link-hover-color,#ffad4d)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$8 = "data-v-d82d7214";
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);

//
var script$7 = {
  name: "ExpansionPanel",
  components: {
    CollapseTransition
  },

  data() {
    return {
      open: false
    };
  },

  props: {
    backgroundColor: {
      type: String,
      default: '#ff8a00'
    }
  },
  methods: {
    toggle() {
      this.open = !this.open;
    }

  }
};

/* script */
const __vue_script__$9 = script$7;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "expansion-panel",
    class: {
      'is-open': _vm.open
    }
  }, [_c('div', {
    staticClass: "toggle",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("toggle"), _vm._v(" "), _c('svg', {
    staticClass: "indicator",
    class: {
      'rotate': _vm.open
    },
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 -4 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 1.25L7 7.25L13 1.25",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])], 2), _vm._v(" "), _c('collapse-transition', {
    attrs: {
      "dimension": "height"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.open,
      expression: "open"
    }],
    staticClass: "content"
  }, [_vm._t("default")], 2)])], 1);
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$9 = function (inject) {
  if (!inject) return;
  inject("data-v-7bcda5c0_0", {
    source: ".expansion-panel[data-v-7bcda5c0]{position:relative;width:100%}.expansion-panel .toggle[data-v-7bcda5c0]{padding-left:20px;padding-right:20px;display:flex;align-items:center;justify-content:flex-start;cursor:pointer;background-color:#ff8a00;width:100%;height:40px;color:#fff}.expansion-panel .indicator[data-v-7bcda5c0]{position:absolute;right:15px;justify-content:center;margin-left:auto;transition:transform ease-in-out .3s}.expansion-panel .indicator.rotate[data-v-7bcda5c0]{transform:rotate(180deg)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$9 = "data-v-7bcda5c0";
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);

let TheHero = class TheHero extends Vue {
  // @Prop() title!: string;
  // @Prop({}) description!: string;
  // @Prop() downloadItems: AsideItem[] | undefined;
  // @Prop() linkItems: AsideItem[] | undefined;
  // @Prop() productImage!: any;
  // @Prop() productsNames: string[] | undefined;
  // @Prop({default: []}) featuresTop: Feature[] | undefined;
  // @Prop({default: []}) featuresBottom: Feature[] | undefined;
  // @Prop() certificates: any[] | undefined;
  get style() {
    return {
      // @ts-ignore
      '--background-image': `url('${this.backgroundImage}')`,
      // @ts-ignore
      '--background-color': this.backgroundColor,
      // @ts-ignore
      '--background-image-overlay': `url('${this.backgroundImageOverlay}')`,
      // @ts-ignore
      '--hero-aside-border-color': this.heroAsideBorderColor
    };
  }

  get allFeatures() {
    // @ts-ignore
    return [...this.featuresTop, ...this.featuresBottom];
  }

};
TheHero = __decorate([Component({
  components: {
    FeatureBlock: __vue_component__$7,
    AsideItemComponent: __vue_component__$8,
    ExpansionPanel: __vue_component__$9
  },
  props: {
    title: String,
    description: String,
    productImage: {},
    productImageProps: {},
    featuresTop: {
      type: Array
    },
    featuresBottom: {
      type: Array
    },
    backgroundColor: {},
    backgroundImage: {},
    backgroundImageOverlay: {},
    downloadsText: {
      type: String
    },
    linksText: {
      type: String
    },
    profitsText: {
      type: String
    },
    downloadItems: {},
    linkItems: {},
    heroAsideBorderColor: {}
  }
})], TheHero);
var script$8 = TheHero;

/* script */
const __vue_script__$a = script$8;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', {
    staticClass: "hero",
    style: _vm.style
  }, [_c('div', {
    staticClass: "hero-wrapper"
  }, [_c('div', {
    staticClass: "hero-container"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "hero-grid container hero-features"
  }, [_c('div', {
    staticClass: "col-features col-features--1  hide-on-mobile"
  }, [_vm._t("before-top-features"), _vm._v(" "), _vm._l(_vm.featuresTop, function (feature, index) {
    return _c('feature-block', {
      key: index,
      attrs: {
        "variant": "ICON_LEFT",
        "feature": feature
      }
    });
  }), _vm._v(" "), _vm._t("after-top-features")], 2), _vm._v(" "), _c('div', {
    staticClass: "col-hero-image"
  }, [_c('img', _vm._b({
    attrs: {
      "src": _vm.productImage,
      "width": "366px",
      "height": "auto"
    }
  }, 'img', _vm.productImageProps, false))]), _vm._v(" "), _c('div', {
    staticClass: "col-features col-features--2 hide-on-mobile"
  }, [_vm._t("before-bottom-features"), _vm._v(" "), _vm._l(_vm.featuresBottom, function (feature, index) {
    return _c('feature-block', {
      key: index,
      attrs: {
        "variant": "ICON_LEFT",
        "feature": feature
      }
    });
  }), _vm._v(" "), _vm._t("after-bottom-features")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm.description ? _c('section', {
    staticClass: "hero-description",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("description"), _vm._v(" "), _c('aside', {
    staticClass: "hero-aside hide-on-mobile"
  }, [_c('div', {
    staticClass: "hero-aside__col"
  }, [_c('p', {
    staticClass: "hero-aside__title"
  }, [_vm._v(_vm._s(_vm.downloadsText) + ":")]), _vm._v(" "), _c('ul', _vm._l(_vm.downloadItems, function (item, index) {
    return _c('aside-item-component', {
      key: index,
      attrs: {
        "item": item
      }
    });
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "hero-aside__col"
  }, [_c('p', {
    staticClass: "hero-aside__title"
  }, [_vm._v(_vm._s(_vm.linksText) + ":")]), _vm._v(" "), _c('ul', _vm._l(_vm.linkItems, function (item, index) {
    return _c('aside-item-component', {
      key: index,
      attrs: {
        "item": item
      }
    });
  }), 1)])])], 2), _vm._v(" "), _c('div', {
    staticClass: "hide-on-desktop"
  }, [_c('expansion-panel', {
    scopedSlots: _vm._u([{
      key: "toggle",
      fn: function () {
        return [_vm._v("\n                        " + _vm._s(_vm.profitsText) + "\n                    ")];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "expansion-panel-content expansion-panel-content--benefits"
  }, _vm._l(_vm.allFeatures, function (feature, index) {
    return _c('div', {
      key: index
    }, [_c('feature-block', {
      staticClass: "feature-list--mobile",
      attrs: {
        "variant": "ICON_LEFT",
        "feature": feature
      }
    })], 1);
  }), 0)]), _vm._v(" "), _c('expansion-panel', {
    scopedSlots: _vm._u([{
      key: "toggle",
      fn: function () {
        return [_vm._v("\n                        " + _vm._s(_vm.linksText) + "\n                    ")];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "expansion-panel-content"
  }, _vm._l(_vm.linkItems, function (item, index) {
    return _c('aside-item-component', {
      key: index,
      attrs: {
        "item": item
      }
    });
  }), 1)]), _vm._v(" "), _c('expansion-panel', {
    scopedSlots: _vm._u([{
      key: "toggle",
      fn: function () {
        return [_vm._v("\n                        " + _vm._s(_vm.downloadsText) + "\n                    ")];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "expansion-panel-content"
  }, _vm._l(_vm.downloadItems, function (item, index) {
    return _c('aside-item-component', {
      key: index,
      attrs: {
        "item": item
      }
    });
  }), 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "hero-container-overlay"
  })], 2)])]);
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$a = function (inject) {
  if (!inject) return;
  inject("data-v-69a5e359_0", {
    source: "img[data-v-69a5e359]{width:100%;height:auto}section.hero[data-v-69a5e359]{padding-top:0}.hero-container[data-v-69a5e359]{background-size:cover;background-color:var(--background-color);background-image:var(--background-image);position:relative;z-index:1}.hero-container-overlay[data-v-69a5e359]{content:\"\";position:absolute;background-image:var(--background-image-overlay);background-size:contain;background-position:right bottom;background-repeat:no-repeat;top:0;bottom:0;left:0;right:0;z-index:-1}.hero-banner[data-v-69a5e359]{position:relative;background-color:#683c11;height:392px}.hero-banner__logo[data-v-69a5e359]{with:100%;max-width:378px}.hero-banner__overlay-wrapper[data-v-69a5e359]{padding:0;position:relative;height:100%}.hero-banner__overlay-wrapper img[data-v-69a5e359]{object-fit:cover;width:auto;height:auto}.hero-banner__overlay[data-v-69a5e359]{max-width:1920px;position:relative;display:flex;justify-content:flex-end;margin:0 auto}.hero-banner__overlay[data-v-69a5e359]:after{content:\"\";position:absolute;left:0;top:0;bottom:0;width:100%;height:100%;background:linear-gradient(90deg,#683c11 0,#683c11 22%,rgba(0,51,102,0) 81%)}.hero-banner__content[data-v-69a5e359]{position:absolute;left:0;top:0;right:0;bottom:0;width:100%;height:100%;padding:56px 0 0 0}.hero-banner .container[data-v-69a5e359]{position:relative}.hero-banner__pic[data-v-69a5e359]{position:absolute;right:0;bottom:-50px;height:200px;width:auto;z-index:20}@media (min-width:768px){.hero-banner__pic[data-v-69a5e359]{width:auto;height:auto}}.hero-wrapper[data-v-69a5e359]{position:relative;z-index:5}.hero-title[data-v-69a5e359]{padding-top:0;padding-bottom:32px;font-size:24px;line-height:32px;text-align:left;color:#fff;width:50%}.hero-grid[data-v-69a5e359]{display:grid;margin-bottom:1em}.hero-description[data-v-69a5e359]{width:100%;max-width:730px;margin:0 auto 48px}.hero-features[data-v-69a5e359]{display:grid;padding-top:64px;grid-gap:16px}.hero-features .feature-block[data-v-69a5e359]{color:inherit;margin-bottom:24px}.hero-features-top[data-v-69a5e359]{grid-template-columns:repeat(3,1fr);margin-bottom:64px}.hero-features-bottom[data-v-69a5e359]{grid-template-columns:repeat(4,1fr);margin-bottom:48px}.certificates[data-v-69a5e359]{margin:32px 0;order:4;width:80%}.col-features[data-v-69a5e359]{display:flex;align-items:center;flex-direction:column}.col-features--1[data-v-69a5e359]{order:2}.col-features--2[data-v-69a5e359]{order:3}.col-hero-image[data-v-69a5e359]{display:flex;flex-direction:column;align-items:center;order:1}.col-hero-image svg[data-v-69a5e359]{margin:8px auto 60px;max-width:288px;width:100%}.col-hero-image img[data-v-69a5e359]{max-width:100%}@media (min-width:768px) and (max-width:979px){[data-v-69a5e359] .feature-block--icon-left{grid-template-columns:65px calc(100% - 65px)}}@media (min-width:768px){.hero-grid[data-v-69a5e359]{grid-template-columns:33% 33% 33%}.hero-title[data-v-69a5e359]{margin-top:0;font-size:40px;line-height:56px;padding-bottom:0}.col-features--1[data-v-69a5e359]{order:1}.col-hero-image[data-v-69a5e359]{order:2}.col-features--2[data-v-69a5e359]{order:3}}",
    map: undefined,
    media: undefined
  }), inject("data-v-69a5e359_1", {
    source: ".hero-aside[data-v-69a5e359]{display:flex;flex-wrap:wrap;border-top:1px solid var(--hero-aside-border-color,#d8c3a1);padding:24px 0;gap:64px}.hero-aside__col[data-v-69a5e359]{display:flex;flex-wrap:wrap;align-items:center;margin-bottom:16px}.hero-aside__title[data-v-69a5e359]{margin:0 16px 0 0;padding:0;font-size:24px;line-height:32px}.hero-aside ul[data-v-69a5e359]{display:flex;flex-wrap:wrap;gap:16px;margin:0;padding:0}",
    map: undefined,
    media: undefined
  }), inject("data-v-69a5e359_2", {
    source: ".expansion-panel.hide-toggle[data-v-69a5e359]>.toggle{display:none}.expansion-panel-content[data-v-69a5e359]{background-color:#fff;padding:16px}.expansion-panel-content[data-v-69a5e359]  li{margin-bottom:16px}.expansion-panel-content--benefits[data-v-69a5e359]{display:grid;grid-template-columns:repeat(1,1fr)}.expansion-panel-content--benefits[data-v-69a5e359]  .feature-block{margin-bottom:32px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$a = "data-v-69a5e359";
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, createInjector, undefined, undefined);

var _dec$2, _class$2;
const defaultOptions = {
  firstRowHeader: true
};
let LdpTable = (_dec$2 = Component({
  props: {
    dataset: {
      default: () => []
    },
    options: {}
  }
}), _dec$2(_class$2 = class LdpTable extends Vue {
  get bodyData() {
    if (this.mergedOptions.firstRowHeader) {
      // @ts-ignore
      let data = [...this.dataset];
      data.shift();
      return data;
    } // @ts-ignore


    return this.dataset;
  }

  get mergedOptions() {
    return { ...defaultOptions,
      // @ts-ignore
      ...this.options
    };
  }

}) || _class$2);

/* script */
const __vue_script__$b = LdpTable;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "ldp-table__wrapper"
  }, [_vm._t("outer-before"), _vm._v(" "), _c('table', {
    staticClass: "ldp-table"
  }, [_vm._t("inner-before"), _vm._v(" "), _vm.mergedOptions.firstRowHeader && _vm.dataset && _vm.dataset[0] ? _c('thead', [_c('tr', _vm._l(_vm.dataset[0], function (column, index) {
    return _c('th', {
      key: index
    }, [_vm._v("\n                " + _vm._s(column) + "\n            ")]);
  }), 0)]) : _vm._e(), _vm._v(" "), _vm.bodyData.length > 0 ? _c('tbody', _vm._l(_vm.bodyData, function (row, index) {
    return _c('tr', {
      key: index,
      class: "row-" + index
    }, _vm._l(row, function (col, colIndex) {
      return _c('td', {
        class: "col-" + colIndex,
        domProps: {
          "innerHTML": _vm._s(col)
        }
      });
    }), 0);
  }), 0) : _vm._e(), _vm._v(" "), _vm._t("inner-after")], 2), _vm._v(" "), _vm._t("outer-after")], 2);
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$b = undefined;
/* scoped */

const __vue_scope_id__$b = undefined;
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var _dec$3, _class$3;
let LdpGraph = (_dec$3 = Component({
  props: {
    dataset: {
      default: () => []
    },
    paddingTop: {
      default: '0px'
    },
    width: {
      default: '100%'
    },
    height: {
      default: '300px'
    },
    unitHeight: {
      default: '54px'
    },
    colWidth: {
      default: '88px'
    },
    lineColor: {
      default: '0, 186, 255'
    },
    colColor: {
      default: '0, 186, 255'
    }
  }
}), _dec$3(_class$3 = class LdpGraph extends Vue {
  get preparedDataset() {
    // @ts-ignore
    return this.dataset;
  }

  get style() {
    return {
      // @ts-ignore
      '--width': this.width,
      // @ts-ignore
      '--height': this.height,
      // @ts-ignore
      '--unit-height': this.unitHeight,
      // @ts-ignore
      '--col-width': this.colWidth,
      // @ts-ignore
      '--col-color': this.colColor,
      // @ts-ignore
      '--line-color': this.lineColor,
      // @ts-ignore
      '--padding-top': this.paddingTop,
      // @ts-ignore
      '--items-count': this.preparedDataset.length
    };
  }

  calcItemHeight(value) {
    return value + 'px';
  }

}) || _class$3);

/* script */
const __vue_script__$c = LdpGraph;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "ldp-graph",
    style: _vm.style
  }, [_c('div', {
    staticClass: "graph"
  }, [_vm._l(_vm.preparedDataset, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "graph__col",
      style: "--col-height: " + _vm.calcItemHeight(item.value)
    }, [_c('img', {
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })]);
  }), _vm._v(" "), _vm._t("graph-inner")], 2), _vm._v(" "), _c('div', {
    staticClass: "graph-titles"
  }, _vm._l(_vm.preparedDataset, function (item, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(item.title))]);
  }), 0)]);
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$c = function (inject) {
  if (!inject) return;
  inject("data-v-5cb06237_0", {
    source: ".ldp-graph[data-v-5cb06237]{padding-top:var(--padding-top)}.graph-titles[data-v-5cb06237]{display:flex;justify-content:space-around;font-size:18px;line-height:32px;color:#fff}.graph[data-v-5cb06237]{height:var(--height);position:relative;display:flex;justify-content:space-around;align-items:flex-end;background:repeating-linear-gradient(to top,rgba(var(--line-color),.5),rgba(var(--line-color),.5) 1px,transparent 1px,transparent calc(var(--unit-height)));border-right:1px solid rgba(var(--line-color),.5)}.graph__col[data-v-5cb06237]{position:relative;height:var(--col-height);width:clamp(20px,calc(100% / var(--items-count) - 10%),88px);background-color:rgba(var(--col-color),.3)}.graph__col img[data-v-5cb06237]{bottom:0;left:50%;position:absolute;transform:translate(-50%,15px)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$c = "data-v-5cb06237";
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, createInjector, undefined, undefined);

export { __vue_component__$9 as ExpansionPanel, __vue_component__$5 as GoToTop, HeaderBottom, HeaderMobile, __vue_component__$1 as HeaderNavigation, HeaderTop, HeaderTopContainer, __vue_component__$3 as LanguageSwitcher, __vue_component__$c as LdpGraph, __vue_component__$b as LdpTable, __vue_component__$2 as MobileNavigation, __vue_component__$4 as StickyFooter, __vue_component__ as StickyHeader, __vue_component__$a as TheHero, __vue_component__$6 as VideoBlock };
